(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', './utilities'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./utilities'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.utilities);
        global.isMaxLength = mod.exports;
    }
})(this, function (exports, _utilities) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (config) {
        return function (value) {
            if ((0, _utilities.isArray)(value) || (0, _utilities.isString)(value) || (0, _utilities.isObjectLike)(value) && (0, _utilities.isNumber)(value.length)) {
                return value.length > config.length ? config.message : null;
            }

            return (0, _utilities.isInvalidType)(value, [_utilities.Types.array, _utilities.Types.string]);
        };
    };
});